import request from '@/utils/request'

// 取得卡主或操作员可发送信息列表
export function getChatMessageList(params) {
  return request({
    url: '/device/chatRecord/getChatMessageList',
    method: 'get',
    params: params,
  })
}

// 获取功能或邀请码用户列表
export function getLabUserList(params) {
  return request({
    url: `/device/labFunction/getUserList`,
    method: 'get',
    params: params,
  })
}

// 用户取得实验室功能列表
export function getLabFunctionByUser(id) {
  return request({
    url: `/device/labFunction/getLabFunctionByUser/${id}`,
    method: 'get',
  })
}

// 取得所有邀请码
export function getInvitationCodeList(params) {
  return request({
    url: '/device/labFunction/getInvitationCodeList',
    method: 'get',
    params: params,
  })
}

// 产生邀请码
export function createInvitationCode(data) {
  return request({
    url: '/device/labFunction/createInvitationCode',
    method: 'post',
    data: data,
  })
}

// 编辑邀请码使用人数
export function editInvitationCodeNumber(data) {
  return request({
    url: '/device/labFunction/editInvitationCodeNumber',
    method: 'post',
    data: data,
  })
}

// 取得实验室功能列表
export function getLabFunctionList(params) {
  return request({
    url: '/device/labFunction/getLabFunctionList',
    method: 'get',
    params: params,
  })
}

// 删除实验室功能
export function deleteLabFunction(id) {
  return request({
    url: `/device/labFunction/deleteLabFunction/${id}`,
    method: 'delete',
  })
}

// 修改实验室功能
export function updateLabFunction(id, data) {
  return request({
    url: `/device/labFunction/updateLabFunction/${id}`,
    method: 'patch',
    data: data,
  })
}

// 新增实验室功能
export function addLabFunction(data) {
  return request({
    url: '/device/labFunction/addLabFunction',
    method: 'post',
    data: data,
  })
}

// 获取协议代理列表
export function deviceProxyMenus() {
  return request({
    url: '/device/proxy/menu',
    method: 'get',
  })
}

// 停止线路
export function stopPushFaceVideoStreaming(data) {
  return request({
    url: '/device/cloudPhone/streaming/stop',
    method: 'post',
    data: data,
  })
}

// 推送臉部視頻流
export function pushFaceVideoStreaming(data) {
  return request({
    url: '/device/cloudPhone/streaming/push',
    method: 'post',
    data: data,
  })
}

// 获取所有設備
export function allCloudPhone(params) {
  return request({
    url: '/device/cloudPhone/allCloudPhone',
    method: 'get',
    params: params,
  })
}

// 删除设备
export function deleteCloudPhone(id) {
  return request({
    url: `/device/cloudPhone/deleteCloudPhone/${id}`,
    method: 'delete',
  })
}

// 修改设备
export function updateCloudPhone(id, data) {
  return request({
    url: `/device/cloudPhone/updateCloudPhone/${id}`,
    method: 'patch',
    data: data,
  })
}

// 取得设备列表
export function listCloudPhones(params) {
  return request({
    url: '/device/cloudPhone/listCloudPhones',
    method: 'get',
    params: params,
  })
}

// 新增设备
export function addCloudPhone(data) {
  return request({
    url: '/device/cloudPhone/addCloudPhone',
    method: 'post',
    data: data,
  })
}

// 取得装置信息
export function getDeviceInfo(deviceNo) {
  return request({
    url: `/device/cloudPhone/getDeviceInfo/${deviceNo}`,
    method: 'post',
  })
}

// 取得代理池列表
export function deviceProxyList(params) {
  return request({
    url: '/device/proxy/list',
    method: 'get',
    params: params,
  })
}

// 修改代理池
export function deviceProxyEdit(data) {
  return request({
    url: '/device/proxy/updatePool',
    method: 'post',
    data: data,
  })
}

// 新增代理池
export function deviceProxyAdd(data) {
  return request({
    url: '/device/proxy/addPool',
    method: 'post',
    data: data,
  })
}


// WEBPACK FOOTER //
// ./src/api/device.js